<div class="onboarding-wrapper">
  <div class="onboarding-left-content">
    <img class="onboarding-rosie-logo" src='assets/images/rosie-icon-logo.svg' alt="Rosie Logo">
    <div class="banned-wrapper">
      <div class="banned-account-heading">
        Oops, there was an issue with your email address. </div>
      <div class="banned-account-subheading">
        There appears to be a problem with the email address you used to create your account with Rosie. <br><br>
        Perhaps a typo or an email that is no longer in use?<br><br>
        You can try again by <span [routerLink]="['/register']" class="text-underline pointer">creating another account here</span> or reach out to <a href="mailto:support@heyrosie.com" class="text-underline">support@heyrosie.com</a> and we'll get you squared away.
      </div>
    </div>
  </div>
  <div class="onboarding-right-content">
    <div class="onboarding-right-content-wrapper">
      <img class="onboarding-rosie-logo" src='assets/images/rosie-icon-logo.svg' alt="Rosie Logo">
    </div>
  </div>
</div>